export default "__VITE_ASSET__BySo3uJF__"